import { Link, useLocation } from 'react-router-dom';
import { Home, Sparkles } from 'lucide-react';

/**
 * Shared site header. Shows the clickable Clinity logo (→ /) and a compact
 * "Home" button. Renders on every page EXCEPT the landing page (which has
 * its own hero-integrated nav).
 */
function SiteHeader() {
  const location = useLocation();
  if (location.pathname === '/') return null;

  return (
    <header
      className="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-[#E2E8F0]"
      data-testid="site-header"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-3 flex items-center justify-between">
        {/* Clickable logo → home */}
        <Link
          to="/"
          className="flex items-center gap-2 group"
          data-testid="site-header-logo"
          aria-label="Clinity home"
        >
          <div
            className="w-9 h-9 rounded-xl flex items-center justify-center text-white shadow-soft group-active:scale-95 transition-transform"
            style={{ background: 'linear-gradient(135deg, #4F46E5 0%, #6366F1 100%)' }}
          >
            <Sparkles className="w-4 h-4" />
          </div>
          <span
            className="text-[15px] font-bold text-[#0F172A] tracking-tight"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Clinity
          </span>
        </Link>

        {/* Home button */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-white border border-[#E2E8F0] hover:border-[#4F46E5] hover:text-[#4F46E5] text-[#334155] text-sm font-medium transition-all shadow-soft active:scale-[0.97]"
          data-testid="site-header-home-btn"
        >
          <Home className="w-4 h-4" />
          <span>Home</span>
        </Link>
      </div>
    </header>
  );
}

export default SiteHeader;
